import { ROBOT_STATUS_DATA_KEYS } from 'Config/websocketConstants';

const ROBOT_STATUS_COLORS = {
  GREEN: '#12B76A',
  GOLD: '#FBC348',
  RED: '#FF5C5C',
  GREY: '#D0D5DD',
  BLACK: '#000000',
};

// selectedRobotLiveStatus: latest ws status payload; undefined/stale-dropped = offline
export const checkRobotStatusColor = (
  selectedRobotLiveStatus,
  userHasAccess,
) => {
  if (!userHasAccess) {
    return ROBOT_STATUS_COLORS.RED;
  }
  if (!selectedRobotLiveStatus) { // No fresh status = offline
    return ROBOT_STATUS_COLORS.GREY;
  }
  const clientCount = Number(selectedRobotLiveStatus[ROBOT_STATUS_DATA_KEYS.CLIENT_CNT]);
  return clientCount > 0 ? ROBOT_STATUS_COLORS.GOLD : ROBOT_STATUS_COLORS.GREEN;
};
